(function () {
  const ZOOM = 3;

  // ── 1. Inject cursor element ──
  const cursor = document.createElement('div');
  cursor.id = 'glm-zoom-cursor';
  cursor.textContent = '+';
  document.body.appendChild(cursor);

  // ── 2. Inject styles ──
  const style = document.createElement('style');
  style.textContent = `
    #glm-zoom-cursor {
      position: fixed;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      border: none;
      background-color: transparent;
      display: none;
      align-items: center;
      justify-content: center;
      pointer-events: none;
      transform: translate(-50%, -50%);
      z-index: 99999;
      font-size: 20px;
      font-weight: 300;
      color: #000000;
      line-height: 1;
      user-select: none;
    }
    #glm-zoom-cursor::before{
      content: '';
      background-color: #ffffff;
      position: absolute;
      border-radius: 50%;
      width:calc(100% - 2px);
      height:calc(100% - 2px);
      top: 1px;
      left: 1px;
      z-index: -1;      
    }
    #glm-zoom-cursor img {
      width: 100%;
      height: auto;
    }

    .glm-zoom-frame {
      overflow: hidden !important;
      cursor: none !important;
      position: relative;
    }

    .glm-zoom-frame img {
      transform-origin: 0 0 !important;
      will-change: transform;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      image-rendering: -webkit-optimize-contrast;
      pointer-events: none;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `;
  document.head.appendChild(style);

  // ── 3. State ──
  let activeFrame = null;

  // ── 4. Move cursor with mouse ──
  window.addEventListener('mousemove', (e) => {
    if ('ontouchstart' in window || navigator.maxTouchPoints > 0) return;
    cursor.style.left = e.clientX + 'px';
    cursor.style.top  = e.clientY + 'px';
  });

  // ── 5. Zoom helper ──
  function applyZoom(img, wrapper, clientX, clientY, animate) {
    const rect = wrapper.getBoundingClientRect();
    const tx = -((clientX - rect.left) / rect.width  * rect.width  * (ZOOM - 1));
    const ty = -((clientY - rect.top)  / rect.height * rect.height * (ZOOM - 1));
    const t  = `translate(${tx}px, ${ty}px) scale(${ZOOM})`;
    if (animate) {
      img.style.transition = 'transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)';
      img.style.webkitTransition = 'transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)';
      img.style.transform = t;
      img.style.webkitTransform = t;
      setTimeout(() => {
        img.style.transition = 'none';
        img.style.webkitTransition = 'none';
      }, 350);
    } else {
      img.style.transform = t;
      img.style.webkitTransform = t;
    }
  }

  // ── 6. Init zoom ──
  function initZoom() {
    const wrappers = document.querySelectorAll(
      '.text-link.product-single__thumbnail.lightBoxImage, ' +
      '.product-single__photo, ' +
      '.product-image-slider-box .slick-slide'
    );

    wrappers.forEach(wrapper => {
      if (wrapper.dataset.zoomInit) return;
      wrapper.dataset.zoomInit = 'true';

      const img = wrapper.querySelector('img');
      if (!img) return;

      // Save original src
      if (!img.dataset.src) img.dataset.src = img.src;

      // Preload hi-res so Safari has it cached before zoom
      if (img.dataset.zoom) {
        const preload = new Image();
        preload.src = img.dataset.zoom;
      }

      wrapper.classList.add('glm-zoom-frame');

      if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
          wrapper.style.cursor = 'pointer';
      }

      wrapper.addEventListener('mouseenter', () => {
        cursor.style.display = 'flex';
        cursor.innerHTML = activeFrame === wrapper ? '<img src="https://cdn.shopify.com/s/files/1/2574/2560/files/Minus.png?v=1783322541">' : '<img src="https://cdn.shopify.com/s/files/1/2574/2560/files/Plus.png?v=1783322540">';
      });

      wrapper.addEventListener('mouseleave', () => {
        cursor.style.display = 'none';
      });

      wrapper.addEventListener('mousemove', (e) => {
        if (activeFrame !== wrapper) return;
        applyZoom(img, wrapper, e.clientX, e.clientY, false);
      });

      wrapper.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (activeFrame === wrapper) {
          // Zoom OUT
          resetFrame(wrapper, img);
          activeFrame = null;
          cursor.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/2574/2560/files/Plus.png?v=1783322540">';
        } else {
          // Reset any previously active frame
          if (activeFrame) resetFrame(activeFrame, activeFrame.querySelector('img'));

          activeFrame = wrapper;
          cursor.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/2574/2560/files/Minus.png?v=1783322541">';

          const clickX = e.clientX;
          const clickY = e.clientY;

          if (img.dataset.zoom) {
            // Swap to hi-res first, zoom after loaded (Safari fix)
            img.src = img.dataset.zoom;
            img.onload = function() {
              img.onload = null;
              applyZoom(img, wrapper, clickX, clickY, true);
            };
          } else {
            applyZoom(img, wrapper, clickX, clickY, true);
          }
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && activeFrame === wrapper) {
          resetFrame(wrapper, img);
          activeFrame = null;
          cursor.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/2574/2560/files/Plus.png?v=1783322540">';
        }
      });
    });
  }

  // ── 7. Reset frame ──
  function resetFrame(frame, img) {
    if (!frame || !img) return;
    img.style.transition = 'transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)';
    img.style.webkitTransition = 'transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)';
    requestAnimationFrame(() => {
      img.style.transform = 'translate(0,0) scale(1)';
      img.style.webkitTransform = 'translate(0,0) scale(1)';
      setTimeout(() => {
        img.style.transition = '';
        img.style.webkitTransition = '';
        if (img.dataset.src) img.src = img.dataset.src;
      }, 350);
    });
  }

  // ── 8. Run ──
  document.addEventListener('DOMContentLoaded', () => {
    initZoom();
    setTimeout(initZoom, 800);
    setTimeout(initZoom, 1500);
    document.addEventListener('init', initZoom);
  });

})();